/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


import React from 'react'
import "../../App.css";
import './MobileHeroSection.css';
import { Button } from "./Button";
//eslint-disable-next-line
import { LiveButton } from './LiveButton';

function MobileHeroSection() {


    
    return (
        <div  loading="eager"  className='hero-container'>
           <h1>MASTERED TRAX</h1>
            <p>SITIO OFICIAL</p>
            <div className='social-icons'>
                <a className='social-icon-link facebook' target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/OfficialMasteredTrax"><i className='fab fa-facebook-f' /></a>
                <a className='social-icon-link instagram' target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/masteredtrax/"><i className='fab fa-instagram' /></a>
                <a className='social-icon-link youtube' target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/@MasteredTraxVEVO"><i className='fab fa-youtube' /></a>
                <a className='social-icon-link twitter' target="_blank" rel="noopener noreferrer" href="https://twitter.com/MasteredTrax"><i className='fab fa-twitter' /></a>
    </div>    
          <div className="hero-btns">
                <Button className='btns' buttonStyle='btn--primary' buttonSize='btn--large' > <i className='fa fa-shopping-cart'/> Tienda</Button>
                <LiveButton className='btns' buttonStyle='btn--primary' buttonSize='btn--large'><i className='fa fa-video-camera'/> Estreno</LiveButton>
            </div>   
            {/* <p id='liveLabel'>HOY TRANSMISIÓN EN VIVO 8PM PT // 10PM Centro // 11PM NEW YORK // 12PM TOKYO</p> */}
        </div>
    )
}

export default MobileHeroSection